export function SobreNosotrosPage() {
  return (
    <section className="px-4 sm:px-6 md:px-14 py-10 md:py-16 max-w-3xl mx-auto flex flex-col gap-5">
      <h1 className="text-4xl font-display font-semibold text-wood">Sobre Nosotros</h1>
      <p className="text-[15px] leading-relaxed text-ink-muted">
        Santtesanía nace del trabajo de artesanos peruanos dedicados a la elaboración de artículos
        religiosos: rosarios, estampas, velas, cruces y medallas hechos a mano con materiales como
        madera de olivo, semillas de hayruro y macramé tradicional.
      </p>
      <p className="text-[15px] leading-relaxed text-ink-muted">
        Trabajamos con clientes individuales que buscan un artículo para su fe o para regalar, y
        también con parroquias, colegios y negocios que compran por volumen a precios especiales por
        docena o ciento.
      </p>
      <p className="text-[15px] leading-relaxed text-ink-muted">
        Cada pedido se coordina directamente contigo por WhatsApp, para que el pago y la entrega se
        ajusten a lo que mejor te convenga.
      </p>
    </section>
  );
}
